// eslint-disable-next-line import/prefer-default-export
export const WEEKENDS = {
  Sunday: 6,
  Saturday: 0,
};
